import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { useId } from 'react';
import { TexfieldProps, IconPosition } from './TextField.types';

const TextField = ({
  label,
  name,
  helpText,
  value,
  placeholder,
  handleChange,
  labelStyle,
  inputStyle,
  textAreaStyle,
  icon,
  onClickIcon,
  iconPosition = IconPosition.RIGHT,
  type,
  keyfilter,
  textFieldType,
  register,
  errorStyle,
  borderStyle,
  className,
  rows = 3,
}: TexfieldProps) => {
  const id = useId();

  if (textFieldType === 'input') {
    return (
      <div className="flex flex-col flex-grow gap-2">
        {label && (
          <label
            className="text-white text-[12.6px] font-medium leading-[13.65px] opacity-[0.88]"
            htmlFor={`${id}-${name}`}
            style={{ ...labelStyle }}
          >
            {label}
          </label>
        )}
        <div>
          <div
            className={`flex items-center rounded-[6px]  relative ${borderStyle}`}
          >
            {iconPosition === IconPosition.LEFT && icon && (
              <span onClick={onClickIcon}>{icon}</span>
            )}
            <InputText
              type={type}
              unstyled
              className={`focus:outline-none rounded-[6px]  w-full min-h-12 px-3 bg-transparent text-white text-[13.8px] font-raleway placeholder-[#939393] ${className}`}
              id={`${id}-${name}`}
              keyfilter={keyfilter}
              aria-describedby={`${name}-help`}
              value={value}
              onChange={handleChange}
              placeholder={placeholder}
              style={{ ...inputStyle }}
              name={name}
              {...register}
            />
            {iconPosition === IconPosition.RIGHT && icon && (
              <span onClick={onClickIcon} className="absolute right-3">
                {icon}
              </span>
            )}
          </div>
        </div>
        <small className={`font-raleway ${errorStyle}`} id={`${name}-help`}>
          {helpText}
        </small>
      </div>
    );
  }

  if (textFieldType === 'textarea') {
    return (
      <div className="flex flex-col mt-5">
        {label && (
          <label
            className="text-white text-sm font-medium opacity-[0.88]"
            htmlFor={`${id}-${name}`}
            style={{ ...labelStyle }}
          >
            {label}
          </label>
        )}
        <div className="flex items-center  rounded-[6px] border-none">
          <InputTextarea
            autoResize
            value={value}
            rows={rows}
            cols={30}
            placeholder={placeholder}
            onChange={handleChange}
            unstyled
            style={{ ...textAreaStyle }}
            name={name}
            {...register}
            className={`focus:outline-none rounded-[6px]  w-full min-h-12 px-3 bg-transparent text-white text-[13.8px] font-raleway placeholder-[#939393] pt-2 ${className}`}
          />
        </div>
        <small className={`font-raleway ${errorStyle}`} id={`${name}-help`}>
          {helpText}
        </small>
      </div>
    );
  }
  return null;
};

export default TextField;
